module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.0-rc.51-74.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.1.0-rc.51.md
// module id = 490
// module chunks = 362